module.exports = __webpack_public_path__ + "img/Casino.7f2cafe.webp";